import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage: Storage | null = null;

  constructor(private storageCtrl: Storage) {}

  // Inicializa la base de datos
  async init() {
    try {
        if (!this.storage) {
          this.storage = await this.storageCtrl.create(); // Crea la base de datos de almacenamiento
        }
      } catch (error) {
        console.error('Error initializing storage:', error);
      }
  }

  // Obtiene el valor de una clave
  async get(key: string): Promise<any> {
    try {
        if (!this.storage) {
          console.error('Storage is not initialized');
          return null;
        }
    } 
    catch (error) {
            console.error('Error getting storage:', error);
    }
    return await this.storage.get(key);
}

  // Guarda un valor
  set(key: string, value: any): Promise<void> {
    if (!this.storage) {
      console.error('Storage is not initialized');
      return Promise.reject('Storage is not initialized');
    }
    return this.storage.set(key, value);
  }
}
